// Centralización de assets y helper para normalizar nombres de reacciones
// Evita duplicar objetos reactionRoutes en múltiples componentes y problemas de fallback.

export const REACTION_ASSETS: Record<string, any> = {
  fire: require('../../../../assets/reactions/fire.png'),
  party: require('../../../../assets/reactions/party.png'),
  smile: require('../../../../assets/reactions/smile.png'),
  heart: require('../../../../assets/reactions/heart.png'),
  like: require('../../../../assets/reactions/likee.png'), // mantener alias
  likee: require('../../../../assets/reactions/likee.png'),
  clap: require('../../../../assets/reactions/clap.png'),
  thinking: require('../../../../assets/reactions/thinking.png'),
  confused: require('../../../../assets/reactions/thinking.png'),
  angry: require('../../../../assets/reactions/angry.png'),
}

const NORMALIZATION_MAP: Record<string, string> = {
  likee: 'like', // interno simplificado
}

export function normalizeReactionName(raw?: string) {
  if (!raw) return 'like'
  const n = raw.trim().toLowerCase()
  return NORMALIZATION_MAP[n] || n
}

export function getReactionAsset(name?: string) {
  const n = normalizeReactionName(name)
  return REACTION_ASSETS[n] || REACTION_ASSETS.like || REACTION_ASSETS.heart
}

// Helper para clonar/ajustar counts optimistas
export function applyOptimisticReaction(
  reactions: any[],
  previousUserReactionId: string | null,
  newReactionId: string | null,
) {
  const next = reactions.map(r => ({ ...r }))
  if (previousUserReactionId && previousUserReactionId !== newReactionId) {
    const prev = next.find(r => (r.reaction_id||r._id)?.toString?.() === previousUserReactionId)
    if (prev && prev.count > 0) prev.count -= 1
  }
  if (newReactionId) {
    const cur = next.find(r => (r.reaction_id||r._id)?.toString?.() === newReactionId)
    if (cur) cur.count = (cur.count || 0) + 1
  }
  return next
}
